import React from 'react';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import type { TaxonomyTheme } from '../../../../types/uncinc_profile/taxonomy';
import TaxonomyThemeTeaserChild from './Child';
import TaxonomyThemeTeaserParent from './Parent';

export interface ThemeProps {
  entity: ImmutableEntity<TaxonomyTheme>;
}

const TaxonomyThemeTeaser: React.FC<ThemeProps> = ({ entity }) => {
  const theme = entity.toJS();
  const parent = theme.parent[0]?.target_id;

  // If the taxonomy has a parent, it must be a child.
  if (parent) {
    return <TaxonomyThemeTeaserChild entity={entity} />;
  }

  // If the taxonomy has no parent, itself must be a parent.
  return <TaxonomyThemeTeaserParent entity={entity} />;
};

export default TaxonomyThemeTeaser;
